import { render, staticRenderFns } from "./TabsDashboardFlights.vue?vue&type=template&id=8cf45fa0&"
import script from "./TabsDashboardFlights.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardFlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports